// ============================================================================
// NavScopeTotals
// ----------------------------------------------------------------------------
// The QuoteMaker top-nav Items + Total readout (Peter v5.41.187; extended to
// Stage 5 + de-bordered v5.41.193). A borderless two-cell strip: the scope/
// quote item count and the large orange running total. Replaces both the old
// verbose Scope Builder pill and the green "Final quote" pill.
//
// TS-060 / DEC-COUNCIL-015 T3 (QuoteMakerNavBar sub-slice 2): extracted VERBATIM
// from App.jsx's top-nav render (behaviour-preserving; only type annotations,
// this header, and identifier->prop renames added). App keeps the visibility
// gate AND the entire computation IIFE (item count, total, GST-label, title) —
// this is a pure presentational leaf that receives the already-computed display
// values. No pipeline state moves in; `fmtNavMoney` and the `*ForNav` derived
// values stay single-source in App.
// ============================================================================

import React from 'react';

interface NavScopeTotalsProps {
    /** The scope/quote item count. */
    items: number;
    /** The total's label ("Total inc GST" or "Subtotal ex GST"). */
    totalLabel: string;
    /** The pre-formatted total string (App applies `fmtNavMoney`). */
    totalDisplay: string;
    /** The readout's hover title (differs for Stage 4 scope vs Stage 5 quote). */
    title: string;
}

export function NavScopeTotals({ items, totalLabel, totalDisplay, title }: NavScopeTotalsProps) {
    return (
        <div className="hidden md:flex items-center relative z-10 qm-nav-scope-totals" role="status" aria-live="polite" title={title}>
            <div className="qm-nav-scope-totals__cell">
                <span className="qm-nav-scope-totals__label">Items</span>
                <span className="qm-nav-scope-totals__num">{items}</span>
            </div>
            <span className="qm-nav-scope-totals__sep" aria-hidden="true" />
            <div className="qm-nav-scope-totals__cell">
                <span className="qm-nav-scope-totals__label">{totalLabel}</span>
                <span className="qm-nav-scope-totals__total">{totalDisplay}</span>
            </div>
        </div>
    );
}
